(function () {
  "use strict";
  var root = document.querySelector("[data-jk-signup]");
  if (!root || root.jkDispose) return;
  var disposed = false;
  var pendingRequests = new Set();
  var I18N = window.JK_I18N || {};
  var supported = ["sv", "fi", "en", "de"];
  var requested = new URL(location.href).searchParams.get("lang") || root.dataset.language || document.documentElement.lang || "sv";
  var lang = requested.toLowerCase().split("-")[0];
  if (supported.indexOf(lang) < 0) lang = "sv";
  root.lang = lang;
  var savedFields = {};
  var activeDialog = null;
  var modalOpener = null;
  var previousOverflow = "";
  var calendarScript = null;
  function closeLegal(restore) {
    if (!activeDialog) return;
    var dialog = activeDialog; activeDialog = null;
    if (typeof dialog.close === "function") dialog.close(); else dialog.removeAttribute("open");
    Array.from(root.children).forEach(function (child) { child.inert = false; });
    document.body.style.overflow = previousOverflow;
    if (restore !== false && modalOpener && modalOpener.isConnected) modalOpener.focus();
  }
  function openLegal(id, opener) {
    var previousOpener = activeDialog ? modalOpener : opener;
    closeLegal(false);
    var dialog = root.querySelector("#" + id); if (!dialog) return;
    modalOpener = previousOpener || document.activeElement;
    activeDialog = dialog; previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    if (typeof dialog.showModal === "function") dialog.showModal();
    else { dialog.setAttribute("open", ""); Array.from(root.children).forEach(function (child) { if (child !== dialog) child.inert = true; }); }
    dialog.querySelector("button").focus();
  }
  function remember() {
    root.querySelectorAll("form input, form select").forEach(function (input) { savedFields[input.name] = input.type === "checkbox" ? input.checked : input.value; });
  }
  var config;
  var signupComplete = false;
  var restoreLanguageFocus = false;
  var proof = root.dataset.previewProof || "";
  try {
    proof = proof || localStorage.getItem("jk_preview_token") || "";
  } catch (_) {}
  root.jkDispose = function () {
    closeLegal(false);
    var calendar = root.querySelector("[data-jk-root]");
    if (calendar && calendar.jkDispose) calendar.jkDispose();
    if (calendarScript) calendarScript.remove();
    disposed = true;
    pendingRequests.forEach(function (controller) { controller.abort(); });
    pendingRequests.clear();
    proof = "";
    config = null;
    root.dataset.previewProof = "";
    root.replaceChildren();
  };
  function ignored(error) { return disposed || error && error.message === "session_changed"; }
  function t(key) {
    if (config && (config.language === lang || !config.language && lang === "sv") && config.copy && config.copy[key]) return config.copy[key];
    return (I18N[lang] || I18N.sv || {})[key] || key;
  }
  function el(tag, attrs, text) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (key) {
      node.setAttribute(key, attrs[key]);
    });
    if (text) node.textContent = text;
    return node;
  }
  function api(path, body) {
    if (root.hasAttribute("data-preview-proof")) proof = root.dataset.previewProof || "";
    var controller = typeof AbortController === "function" ? new AbortController() : null;
    if (controller) pendingRequests.add(controller);
    var timer = controller ? window.setTimeout(function () { controller.abort(); }, 15000) : null;
    var url = new URL("/apps/julkalender" + path, location.origin);
    if (proof) url.searchParams.set("pv", proof);
    url.searchParams.set("lang", lang);
    if (!body && path === "/signup") {
      var accessToken = new URL(location.href).searchParams.get("t");
      if (accessToken) url.searchParams.set("t", accessToken);
    }
    return fetch(url.pathname + url.search, {
      method: body ? "POST" : "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: body ? JSON.stringify(body) : undefined,
      signal: controller ? controller.signal : undefined,
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (disposed) throw new Error("session_changed");
        return { status: response.status, data: data };
      });
    }).finally(function () {
      if (timer) window.clearTimeout(timer);
      if (controller) pendingRequests.delete(controller);
    });
  }
  function errorText(code) {
    var keys = {
      invalid_email: "signup_invalid_email",
      terms_required: "signup_terms_required",
      adult_required: "signup_adult_required",
      invalid_country: "signup_country_required",
      calendar_email_required: "signup_calendar_email_required",
      policy_review_required: "signup_policy_review_required",
      terms_changed: "signup_terms_changed",
      translation_unavailable: "signup_translation_missing",
      signup_closed: "signup_closed",
      rate_limited: "rate_limited",
      wrong_password: "preview_wrong",
    };
    return t(keys[code] || "signup_error");
  }
  function field(name, key, type, optional, autocomplete) {
    var wrap = el("div", { class: "jk-field" });
    var id = "jk-signup-" + name;
    wrap.appendChild(
      el(
        "label",
        { for: id },
        t(key) + (optional ? " (" + t("field_optional") + ")" : ""),
      ),
    );
    var input = el("input", {
      id: id,
      name: name,
      type: type || "text",
      autocomplete: autocomplete || "off",
      maxlength: type === "email" ? "254" : "100",
    });
    if (!optional) input.required = true;
    wrap.appendChild(input);
    return { wrap: wrap, input: input };
  }
  function select(name, key, options, selected) {
    var item = field(name, key);
    var input = el("select", { name: name, id: item.input.id, required: "" });
    input.appendChild(el("option", { value: "" }, t("field_choose")));
    options.forEach(function (option) {
      input.appendChild(el("option", { value: option[0] }, option[1]));
    });
    input.value = selected || "";
    item.input.replaceWith(input);
    item.input = input;
    return item;
  }
  function checkbox(name, key, required) {
    var label = el("label", { class: "jk-signup-check" });
    var input = el("input", {
      type: "checkbox",
      name: name,
      id: "jk-signup-" + name,
    });
    input.required = required;
    label.appendChild(input);
    label.appendChild(el("span", {}, t(key)));
    return { wrap: label, input: input };
  }
  function inline(node, text) {
    var parts = text.split(/(\[[^\]]+\]\([^)]+\))/g);
    parts.forEach(function (part) {
      var match = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
      if (!match) {
        node.appendChild(document.createTextNode(part.replace(/\*\*/g, "")));
        return;
      }
      if (match[2] === "INTEGRITETSPOLICY-2026.md") {
        var button = el(
          "button",
          { type: "button", class: "jk-signup-link" },
          match[1],
        );
        button.addEventListener("click", function () {
          openLegal("jk-signup-privacy", button);
        });
        node.appendChild(button);
      } else if (/^(https:\/\/|mailto:)/.test(match[2])) {
        node.appendChild(
          el(
            "a",
            { href: match[2], target: "_blank", rel: "noopener noreferrer" },
            match[1],
          ),
        );
      } else {
        node.appendChild(document.createTextNode(match[1]));
      }
    });
  }
  function legal(id, title, markdown) {
    var details = el("dialog", { class: "jk-signup-legal", id: id, "aria-labelledby": id + "-title" });
    var header = el("div", { class: "jk-signup-legal-header" });
    var close = el("button", { type: "button", class: "jk-signup-close", "aria-label": t("signup_close") }, "×");
    close.addEventListener("click", function () { closeLegal(); });
    header.append(el("h2", { id: id + "-title" }, title), close);
    details.appendChild(header);
    details.addEventListener("cancel", function (event) { event.preventDefault(); closeLegal(); });
    details.addEventListener("click", function (event) { if (event.target === details) closeLegal(); });
    details.addEventListener("keydown", function (event) {
      if (event.key === "Escape") { event.preventDefault(); closeLegal(); }
      if (event.key === "Tab") {
        var focusable = Array.from(details.querySelectorAll("button,a[href]"));
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    var content = el("div", { class: "jk-signup-legal-content" });
    var table;
    markdown.split(/\r?\n/).forEach(function (line) {
      if (!line.trim()) {
        table = null;
        return;
      }
      if (/^\|/.test(line)) {
        if (/^\|[\s|:-]+$/.test(line)) return;
        var header = !table;
        if (!table) {
          var scroll = el("div", { class: "jk-signup-table" });
          table = el("table");
          scroll.appendChild(table);
          content.appendChild(scroll);
        }
        var row = el("tr");
        line
          .split("|")
          .slice(1, -1)
          .forEach(function (cell) {
            var td = el(header ? "th" : "td", header ? { scope: "col" } : {});
            inline(td, cell.trim());
            row.appendChild(td);
          });
        table.appendChild(row);
        return;
      }
      table = null;
      var node = el(/^#/.test(line) ? "h3" : "p");
      inline(node, line.replace(/^#+\s*/, ""));
      content.appendChild(node);
    });
    details.appendChild(content);
    return details;
  }
  function render() {
    if (disposed) return;
    closeLegal(false);
    root.lang = lang;
    root.textContent = "";
    var language = select("language", "signup_page_language", [["sv", "Svenska"], ["fi", "Suomi"], ["en", "English"], ["de", "Deutsch"]], lang);
    language.input.querySelector('option[value=""]').remove();
    language.wrap.classList.add("jk-signup-language");
    language.input.addEventListener("change", function () {
      remember(); lang = language.input.value;
      restoreLanguageFocus = true;
      try {
        var address = new URL(location.href); address.searchParams.set("lang", lang);
        history.replaceState(null, "", address.pathname + address.search + address.hash);
      } catch (_) {}
      savedFields.termsAccepted = false;
      load();
    });

    if (config.preview)
      root.appendChild(
        el("p", { class: "jk-signup-preview" }, t("signup_preview")),
      );
    var layout = el("div", { class: "jk-signup-layout" });
    var hero = el("section", {
      class: "jk-signup-hero",
      "aria-labelledby": "jk-signup-title",
    });
    if (root.dataset.image) {
      var artwork = el("div", { class: "jk-signup-artwork" });
      artwork.appendChild(el("img", {
        src: root.dataset.image,
        alt: t("signup_form_eyebrow") + " · GULDVIVA",
        width: "1080", height: "1080", decoding: "async", fetchpriority: "high",
      }));
      hero.appendChild(artwork);
    }
    var heroCopy = el("div", { class: "jk-signup-hero-copy" });
    heroCopy.appendChild(el("div", { class: "jk-signup-decoration", "aria-hidden": "true" }, "✧  ❄  ✧"));
    heroCopy.appendChild(
      el("p", { class: "jk-signup-eyebrow" }, "GULDVIVA · 1–24.12.2026"),
    );
    heroCopy.appendChild(
      el(
        "h1",
        { id: "jk-signup-title" },
        t("signup_heading"),
      ),
    );
    heroCopy.appendChild(
      el(
        "p",
        { class: "jk-signup-lead" },
        t("signup_intro"),
      ),
    );
    heroCopy.appendChild(el("p", { class: "jk-signup-free" }, t("signup_free")));
    if (config.open && !config.participationConfirmed && !signupComplete) {
      var jumpToForm = el("a", { class: "jk-signup-jump", href: "#jk-signup-form-title" }, t("signup_form_title") + " ↓");
      jumpToForm.addEventListener("click", function (event) {
        var emailField = root.querySelector('input[name="email"]');
        if (!emailField) return;
        event.preventDefault();
        emailField.focus();
      });
      heroCopy.appendChild(jumpToForm);
    }
    var steps = el("ol", { class: "jk-signup-short-steps" });
    ["signup_short_step_one", "signup_short_step_two", "signup_short_step_three"].forEach(function (key, index) {
      var step = el("li"); step.append(el("span", { class: "jk-signup-step-number", "aria-hidden": "true" }, String(index + 1)), document.createTextNode(t(key))); steps.appendChild(step);
    });
    heroCopy.appendChild(steps);
    heroCopy.appendChild(el("p", { class: "jk-signup-smallprint" }, t("signup_short_limits")));
    hero.appendChild(heroCopy);
    layout.appendChild(hero);
    var card = el("section", {
      class: "jk-signup-card",
      "aria-labelledby": "jk-signup-form-title",
    });
    card.appendChild(
      el("p", { class: "jk-signup-eyebrow" }, t("signup_form_eyebrow")),
    );
    card.appendChild(
      el("h2", { id: "jk-signup-form-title" }, t(config.participationConfirmed ? "signup_registered_title" : "signup_form_title")),
    );
    if (!config.participationConfirmed && !signupComplete) card.appendChild(
      el("p", { class: "jk-signup-muted" }, t("signup_form_intro")),
    );
    if (!config.participationConfirmed && (signupComplete || !config.open)) card.appendChild(language.wrap);
    if (config.participationConfirmed) {
      card.appendChild(el("p", { role: "status" }, t("signup_registered_text")));
    } else if (signupComplete) {
      card.append(el("div", { class: "jk-signup-success", role: "status", tabindex: "-1" }, t("signup_done_title")), el("p", {}, t("signup_done_text")));
    } else if (!config.open) {
      card.appendChild(el("p", { role: "status" }, t("signup_closed")));
    } else {
      var form = el("form", { class: "jk-signup-form" });
      var email = field("email", "signup_email_label", "email", false, "email");
      var first = field(
        "firstName",
        "field_first_name",
        "text",
        true,
        "given-name",
      );
      var last = field(
        "lastName",
        "field_last_name",
        "text",
        true,
        "family-name",
      );
      var names = el("div", { class: "jk-signup-fields" });
      names.append(first.wrap, last.wrap);
      form.append(email.wrap, names, language.wrap);

      var adult = checkbox("adultConfirmed", "signup_adult", true);
      var terms = checkbox("termsAccepted", "signup_accept_rules", true);
      var newsletter = checkbox("consent", "signup_consent", false);

      var rulesLink = el(
        "a",
        { href: "#jk-signup-rules", class: "jk-signup-read" },
        t("signup_read_rules"),
      );
      rulesLink.addEventListener("click", function (event) { event.preventDefault(); openLegal("jk-signup-rules", rulesLink); });
      terms.wrap.querySelector("span").append(document.createTextNode(" "), rulesLink);
      form.append(adult.wrap, terms.wrap);
      var optional = el("fieldset", { class: "jk-signup-optional" });
      optional.append(el("legend", {}, t("signup_optional_mail")), newsletter.wrap);
      form.appendChild(optional);
      var privacyNote = el(
        "p",
        { class: "jk-signup-help" },
        t("signup_privacy_hint") + " ",
      );
      var privacyLink = el(
        "a",
        { href: "#jk-signup-privacy" },
        t("signup_read_privacy"),
      );
      privacyLink.addEventListener("click", function (event) { event.preventDefault(); openLegal("jk-signup-privacy", privacyLink); });
      privacyNote.appendChild(privacyLink);
      form.appendChild(privacyNote);
      if (config.lastDrawPassed)
        form.appendChild(
          el("p", { class: "jk-signup-preview" }, t("signup_last_day")),
        );
      var error = el("p", {
        role: "alert",
        class: "jk-error",
        id: "jk-signup-error",
      });
      var submit = el(
        "button",
        { type: "submit", class: "jk-signup-submit" },
        t("signup_submit") + " →",
      );
      var mailNotice = el("p", { class: "jk-signup-help jk-signup-mail-notice", id: "jk-calendar-mail-notice" }, t("signup_daily_email"));
      submit.setAttribute("aria-describedby", "jk-calendar-mail-notice");
      form.append(error, mailNotice, submit);
      form.querySelectorAll("input,select").forEach(function (input) {
        if (Object.prototype.hasOwnProperty.call(savedFields, input.name)) {
          if (input.type === "checkbox") input.checked = savedFields[input.name]; else input.value = savedFields[input.name];
        }
      });
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        if (submit.disabled || !form.reportValidity()) return;
        error.textContent = "";
        submit.disabled = true;
        language.input.disabled = true;
        submit.textContent = t("signup_sending");
        form.setAttribute("aria-busy", "true");
        api("/signup", {
          email: email.input.value.trim(),
          firstName: first.input.value,
          lastName: last.input.value,
          language: language.input.value,
          adultConfirmed: adult.input.checked,
          termsAccepted: terms.input.checked,
          termsVersion: config.termsVersion,
          privacyVersion: config.privacyVersion,
          consent: newsletter.input.checked,
          dailyEmailConsent: true,
        })
          .then(function (response) {
            if (response.status === 200 && response.data.ok) {
              signupComplete = true;
              form.replaceChildren(
                el(
                  "div",
                  {
                    class: "jk-signup-success",
                    tabindex: "-1",
                    role: "status",
                  },
                  t("signup_done_title"),
                ),
                el("p", {}, t("signup_done_text")),
              );
              if (newsletter.input.checked && !response.data.confirmationRequired)
                form.appendChild(
                  el(
                    "p",
                    {},
                    t(
                      response.data.marketingPending
                        ? "signup_marketing_pending"
                        : "signup_marketing_done",
                    ),
                  ),
                );
              form.querySelector("[role=status]").focus();
              return;
            }
            if (response.status === 401 && response.data.error === "preview_locked") {
              showLock(function () {
                submit.disabled = false;
                submit.textContent = t("signup_submit") + " →";
              });
              return;
            }
            error.textContent = response.status === 429 ? t("rate_limited") : errorText(response.data.error);
            var target = {
              terms_required: terms.input,
              adult_required: adult.input,
              invalid_email: email.input,
            }[response.data.error];
            if (target) target.focus();
            submit.disabled = false;
            submit.textContent = t("signup_submit") + " →";
          })
          .catch(function (errorThrown) {
            if (ignored(errorThrown)) return;
            error.textContent = t("signup_error");
            submit.disabled = false;
            submit.textContent = t("signup_submit") + " →";
          })
          .finally(function () {
            form.removeAttribute("aria-busy");
            language.input.disabled = false;
          });
      });
      card.appendChild(form);
    }
    layout.appendChild(card);
    root.appendChild(layout);
    root.append(
      legal(
        "jk-signup-rules",
        t("signup_read_rules"),
        config.rules,
      ),
      legal(
        "jk-signup-privacy",
        t("signup_read_privacy"),
        config.privacy,
      ),
    );
    var footer = el(
      "p",
      { class: "jk-signup-footer" },
      "Guldviva AB · 0797569-5 · Sjökvarteret, 22100 Mariehamn · ",
    );
    footer.appendChild(
      el("a", { href: "mailto:info@guldviva.com" }, "info@guldviva.com"),
    );
    root.appendChild(footer);
    if (restoreLanguageFocus) { restoreLanguageFocus = false; language.input.focus(); }
  }
  function showLock(resume) {
    if (disposed) return;
    var overlay = el("div", { class: "jk-signup-lock" });
    var form = el("form", { class: "jk-signup-card" });
    form.append(
      el("h1", {}, t("preview_title")),
      el("p", {}, t("preview_text")),
    );
    var password = field(
      "password",
      "preview_password_label",
      "password",
      false,
      "current-password",
    );
    var error = el("p", { role: "alert", class: "jk-error" });
    var button = el(
      "button",
      { class: "jk-signup-submit", type: "submit" },
      t("preview_submit"),
    );
    form.append(password.wrap, error, button);
    overlay.appendChild(form);
    var children = Array.from(root.children);
    children.forEach(function (child) {
      child.hidden = true;
    });
    root.appendChild(overlay);
    password.input.focus();
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (button.disabled || !form.reportValidity()) return;
      button.disabled = true;
      api("/preview", { password: password.input.value })
        .then(function (response) {
          if (response.status !== 200 || !response.data.pv) {
            error.textContent = response.status === 429 ? t("rate_limited") : errorText(response.data.error);
            return;
          }
          proof = response.data.pv || "";
          root.dataset.previewProof = proof;
          try {
            if (proof) localStorage.setItem("jk_preview_token", proof);
            else localStorage.removeItem("jk_preview_token");
          } catch (_) {}
          root.dispatchEvent(new CustomEvent("jk-preview-updated", { bubbles: true, detail: proof }));
          overlay.remove();
          children.forEach(function (child) {
            child.hidden = false;
          });
          resume();
        })
        .catch(function (errorThrown) {
          if (ignored(errorThrown)) return;
          error.textContent = t("signup_error");
        })
        .finally(function () {
          button.disabled = false;
        });
    });
  }
  function load() {
    var selector = root.querySelector('[name="language"]'); if (selector) selector.disabled = true;
    api("/signup")
      .then(function (response) {
        if (response.status === 401 && response.data.error === "preview_locked") {
          showLock(load);
          return;
        }
        if (response.status !== 200) throw new Error(response.status === 429 ? "rate_limited" : ["translation_unavailable", "policy_review_required"].includes(response.data.error) ? response.data.error : "signup_config");
        config = response.data;
        render();
      })
      .catch(function (error) {
        if (ignored(error)) return;
        root.textContent = "";
        root.appendChild(el("p", { role: "alert" }, errorText(error.message)));
        if (error.message === "translation_unavailable") {
          var swedish = el("button", { type: "button", class: "jk-signup-submit" }, "Svenska");
          swedish.addEventListener("click", function () { lang = "sv"; load(); });
          root.appendChild(swedish);
        }
        var retry = el(
          "button",
          { type: "button", class: "jk-signup-submit" },
          t("signup_retry"),
        );
        retry.addEventListener("click", function () {
          retry.disabled = true;
          load();
        });
        root.appendChild(retry);
      });
  }
  var calendarAccess = new URL(location.href).searchParams.get("t");
  try { calendarAccess = calendarAccess || localStorage.getItem("jk_token"); } catch (_) {}
  if (calendarAccess && root.dataset.calendarSrc) {
    root.replaceChildren();
    var calendar = el("div", { class: "jk-root", "data-jk-root": "", "data-language": lang,
      "data-participant-token": calendarAccess, "data-preview-proof": proof });
    root.appendChild(calendar);
    calendarScript = el("script", { src: root.dataset.calendarSrc });
    calendarScript.onerror = function () { if (!disposed) root.appendChild(el("p", { role: "alert" }, t("signup_error"))); };
    document.head.appendChild(calendarScript);
  } else if (root.jkConfig && (root.jkConfig.language ? root.jkConfig.language === lang : lang === "sv")) {
    config = root.jkConfig;
    render();
  } else {
    load();
  }
})();
